import React from "react";
import CommonImageView from "presentational/common/CommonImageView";
import CommonIconView from "presentational/common/CommonIconView";
import TXT from "presentational/common/multinational/TXT";
import CommonGuideTooltipView from "presentational/common/modals/CommonGuideTooltipView";
import config from "lib/fr-config";
import { withStyles } from "@material-ui/core/styles";
import { getImgUrl } from "lib/imageUrlHelper";
import Typography from "@material-ui/core/Typography";
import styles from "./PolaroidStyleItemUnitView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const fontCss = config.css.fontThickness;
const colorCss = config.css.color;

const CategoryTypography = withStyles({
  root: {
    fontSize: 12,
    lineHeight: 1.3,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
})(Typography);
const BrandTypography = withStyles({
  root: {
    fontSize: 12,
    lineHeight: 1.3,
    fontWeight: fontCss.medium,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
})(Typography);
const NicknameTypography = withStyles({
  root: {
    fontSize: 12,
    lineHeight: 1.3,
    fontWeight: fontCss.medium,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
})(Typography);
const HashTypography = withStyles({
  root: {
    fontSize: 10,
    lineHeight: 1.3,

    /**
     * text overflow 생략 위한 코드.
     */
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
})(Typography);

const css = {
  icon: {
    width: "100%",
    height: "100%",
    color: "rgba(0, 0, 0, 0.7)"
  },
  markedGlass: {
    background: colorCss.backgroundColorOfSelectedItem
  }
};

PolaroidStyleItemUnitView.propTypes = {
  onClick: PropTypes.func.isRequired,

  itemInfo: PropTypes.object,
  isMarkedItem: PropTypes.bool,
  displayItemUnitTooltip: PropTypes.bool,
  isFirstUnit: PropTypes.bool,
  hasClickedItemUnitAtLeastOnce: PropTypes.bool,
  deleteMode: PropTypes.bool
};

PolaroidStyleItemUnitView.defaultProps = {
  itemInfo: null,
  isMarkedItem: false,
  displayItemUnitTooltip: false,
  isFirstUnit: false,
  hasClickedItemUnitAtLeastOnce: false,
  deleteMode: false
};

function PolaroidStyleItemUnitView(props) {
  const {
    onClick,
    itemInfo,
    isMarkedItem,
    displayItemUnitTooltip,
    isFirstUnit,
    hasClickedItemUnitAtLeastOnce,
    deleteMode
  } = props;

  const handleClick = () => {
    onClick(itemInfo);
  };

  const getTextBlock = () => {
    if (!itemInfo) return null;

    const { brand, category, tag, nickname } = itemInfo;

    const hashText = tag ? `#${tag.split("|").join(" #")}` : "";

    return (
      <div>
        <CategoryTypography color={"secondary"}>
          <TXT
            textType="category"
            categoryType="itemLabelName"
            name={category}
          />
        </CategoryTypography>
        <BrandTypography>{brand.toUpperCase()}</BrandTypography>
        <HashTypography>{hashText}</HashTypography>
        {nickname && <NicknameTypography>"{nickname}"</NicknameTypography>}
      </div>
    );
  };

  const getItemUnit = () => {
    return (
      <div className={cx("image-wrapper")}>
        <CommonImageView
          imageSrc={getImgUrl("item", itemInfo.image) || "pending"}
          imageRatio={config.itemImage.RATIO}
        />
        <div className={cx("delete-flag", { hide: !deleteMode })}>
          <CommonIconView type={"close"} style={css.icon} />
        </div>
        <div
          className={cx("glass")}
          style={isMarkedItem ? css.markedGlass : null}
        >
          {isMarkedItem && <CommonIconView type={"check"} style={css.icon} />}
        </div>
      </div>
    );
  };

  const getItemUnitWithTooltip = () => {
    if (displayItemUnitTooltip && isFirstUnit) {
      return (
        <CommonGuideTooltipView
          needClose={hasClickedItemUnitAtLeastOnce}
          needCountUp={false}
          message={<TXT name="msg_tooltipClickNormalBtn" />}
          placement={"top"}
          arrow
          backgroundDesign={"primary"}
          displayForGuest
        >
          {getItemUnit()}
        </CommonGuideTooltipView>
      );
    } else {
      return getItemUnit();
    }
  };

  if (!itemInfo) return <div />;
  else {
    return (
      <div className={cx("root")} onClick={handleClick}>
        {getItemUnitWithTooltip()}
        <div className={cx("text-area")}>{getTextBlock()}</div>
      </div>
    );
  }
}

export default PolaroidStyleItemUnitView;
